export enum PortalStatus {
  Inactive = 'Inactive',
  Active = 'Active',
  Deactivated = 'Deactivated',
}
